import React from 'react';
import './ourServices.scss';

const AutomatizacionServices = () => {
  return (
    <div className="our-services">
      <div className="our-services__container">
        <div className="our-services__content">
          <h2 className="our-services__title">
            Optimización de Espacios Creativos
          </h2>
          <div className="our-services__title-line" />
          <p className="our-services__text">
            Diseñamos ambientes de trabajo que potencian la creatividad, reducen
            el estrés y mejoran el rendimiento de los equipos audiovisuales.
          </p>
          <p className="our-services__text">
            Aplicando principios de neuropsicología ambiental y datos de
            Business Intelligence, analizamos y optimizamos los espacios de
            trabajo de las empresas creativas para promover la salud mental, la
            colaboración y la innovación. Cada elemento del entorno — desde la
            iluminación hasta la distribución del espacio — influye en el
            rendimiento cognitivo y emocional del equipo.
          </p>
          <p className="our-services__text">
            Nuestro enfoque combina ciencia del comportamiento, tecnología y
            diseño para crear entornos donde la creatividad fluye de forma
            natural y los equipos rinden al máximo de su potencial.
          </p>
        </div>
        <div className="our-services__solutions">
          <h3 className="our-services__subtitle">
            Entre nuestras soluciones se incluyen:
          </h3>
          <ul className="our-services__list">
            <li className="our-services__item">
              <p className="our-services__item-title">
                Diagnóstico neuropsicológico del espacio
              </p>
              <p className="our-services__item-desc">
                Evaluamos cómo el entorno físico actual afecta al bienestar, la
                creatividad y el rendimiento del equipo.
              </p>
            </li>
            <li className="our-services__item">
              <p className="our-services__item-title">
                Diseño de ambientes para la creatividad
              </p>
              <p className="our-services__item-desc">
                Proponemos modificaciones basadas en neuropsicología ambiental
                para optimizar la distribución, iluminación y estímulos
                sensoriales.
              </p>
            </li>
            <li className="our-services__item">
              <p className="our-services__item-title">
                Reducción del estrés y mejora del bienestar
              </p>
              <p className="our-services__item-desc">
                Implementamos estrategias para minimizar los factores de estrés
                ambiental que afectan al rendimiento creativo.
              </p>
            </li>
            <li className="our-services__item">
              <p className="our-services__item-title">
                Mejora de la colaboración y la comunicación
              </p>
              <p className="our-services__item-desc">
                Optimizamos la disposición del espacio para favorecer la
                interacción, el intercambio de ideas y el trabajo en equipo.
              </p>
            </li>
            <li className="our-services__item">
              <p className="our-services__item-title">
                Seguimiento con BI y métricas de bienestar
              </p>
              <p className="our-services__item-desc">
                Monitorizamos el impacto de los cambios implementados mediante
                indicadores de bienestar, satisfacción y productividad del
                equipo.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AutomatizacionServices;
